module.exports = __webpack_public_path__ + "static/media/nz.c35868e6.svg";